import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@ludolio/shared-ui';
import { useLabs } from '@/lib/labs-context';
import type { LabUnit } from '@/lib/types';
import { NO_LABS_UNITS_MESSAGE, NO_UNIT } from '@/lib/units';

export function UnitSelect({
  id,
  value,
  onChange,
  disabled,
  units,
  triggerClassName,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  units?: LabUnit[];
  triggerClassName?: string;
}) {
  const labs = useLabs();
  const options = units ?? labs.units;

  if (labs.requiresLabsUnit && options.length === 0) {
    return <p className="text-sm text-muted-foreground">{NO_LABS_UNITS_MESSAGE}</p>;
  }

  return (
    <Select value={labs.requiresLabsUnit && value === NO_UNIT ? '' : value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger id={id} className={triggerClassName}>
        <SelectValue placeholder="Choose a unit" />
      </SelectTrigger>
      <SelectContent>
        {!labs.requiresLabsUnit && <SelectItem value={NO_UNIT}>No unit</SelectItem>}
        {options.map((unit) => (
          <SelectItem key={unit.id} value={unit.id}>
            {unit.code} - {unit.name}{unit.labsEnabled === false ? ' (Labs off)' : ''}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
